// extracted by mini-css-extract-plugin
export default {"storyItem":"c-a_fs","storyItem__circle":"c-a_ft","storyItem__image":"c-a_fu","storyItem__description":"c-a_fv","storyItem_viewAll":"c-a_fw"};